// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {FormArray, FormControl, FormGroup, Validators} from "@angular/forms";
import {Modules, Scenario, ScenarioRecordingState} from "@models";
import {SimConfigurationService} from "@services";
import {Translations} from "@translations";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_ChangeRecordingMetaDialogInput extends MatDialogDataBaseInput {
	eventName: string;
	eventDescription?: string;
	sessionName: string;
	scenario: Scenario;
	scenarioRecordingState: ScenarioRecordingState;
}

export interface DialogData_ChangeRecordingMetaDialogOutput extends MatDialogDataBaseOutput {
	eventName?: string;
	eventDescription?: string;
	sessionName?: string;
	scenario?: Scenario;
}

@Component({
	selector: "sim-open-change-recording-meta-dialog",
	templateUrl: "./open-change-recording-meta-dialog.component.html",
	styleUrls: ["./open-change-recording-meta-dialog.component.scss"],
	standalone: false,
})
export class OpenChangeRecordingMetaDialogComponent extends BasicMaterialDialog<
	OpenChangeRecordingMetaDialogComponent,
	DialogData_ChangeRecordingMetaDialogInput,
	DialogData_ChangeRecordingMetaDialogOutput
> {
	T = Translations;
	ScenarioRecordingState = ScenarioRecordingState;

	metaDataForm = new FormGroup({
		eventName: new FormControl(""),
		eventDescription: new FormControl(""),
		sessionName: new FormControl(""),
		scenario: new FormArray<FormControl<Scenario>>([], [Validators.required]),
	});

	hasLicenseModule = SimConfigurationService.hasLicenseModule;
	Modules = Modules;

	constructor(_injector: Injector) {
		super(_injector);

		if (this.data.eventName) {
			this.metaDataForm.controls.eventName.setValue(this.data.eventName);
		}

		if (this.data.sessionName) {
			this.metaDataForm.controls.sessionName.setValue(this.data.sessionName);
		}

		if (this.data.eventDescription) {
			this.metaDataForm.controls.eventDescription.setValue(this.data.eventDescription);
		}

		if (this.data.scenario) {
			this.metaDataForm.controls.scenario.push(new FormControl(this.data.scenario));
		}
	}

	okButtonClicked() {
		const {eventName, eventDescription, sessionName, scenario} = this.metaDataForm.value;
		this.close({
			action: "ok",
			eventName,
			sessionName,
			scenario: scenario[0],
			eventDescription,
		});
	}
}
